/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventlimitreachedcreateblocked4Inputs */

const en_eventlimitreachedcreateblocked4 = /** @type {(inputs: Eventlimitreachedcreateblocked4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You've reached your event limit. Upgrade your plan to create more events.`)
};

const de_eventlimitreachedcreateblocked4 = /** @type {(inputs: Eventlimitreachedcreateblocked4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast dein Event-Limit erreicht. Wechsle deinen Plan, um weitere Events zu erstellen.`)
};

/**
* | output |
* | --- |
* | "You've reached your event limit. Upgrade your plan to create more events." |
*
* @param {Eventlimitreachedcreateblocked4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventlimitreachedcreateblocked4 = /** @type {((inputs?: Eventlimitreachedcreateblocked4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventlimitreachedcreateblocked4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventlimitreachedcreateblocked4(inputs)
	return de_eventlimitreachedcreateblocked4(inputs)
});
export { eventlimitreachedcreateblocked4 as "eventLimitReachedCreateBlocked" }